export default "__VITE_ASSET__7323747a__"